// extracted by mini-css-extract-plugin
export default {"wrapper":"contactdata_wrapper__lqbht"};